import { render, staticRenderFns } from "./master-transporter.vue?vue&type=template&id=a18c76b2&scoped=true"
import script from "./master-transporter.vue?vue&type=script&lang=js"
export * from "./master-transporter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a18c76b2",
  null
  
)

export default component.exports